export default "__VITE_ASSET__628cf65c__"